export const dateFormat = fecha => {
    let dateInitial
    if(String(fecha).length === 7){
        dateInitial = fecha
    }
    else{
        dateInitial = "1210101"
    }
    

    let anio = String(dateInitial).slice(1, 3);
    let mes = String(dateInitial).slice(3, 5);
    let dia = String(dateInitial).slice(5, 7);

    let meses = ['Ene','Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

    //let fechaFormat = `${anio}-${mes}-${dia}`;
    //let fechaFormat = `${dia}-${mes}-${anio}`;
    let fechaFormat = `${dia}-${meses[Number(mes - 1)]}-${anio}`;

    return fechaFormat
}
export const dateFormatDDMMYY = fecha => {
    let dateInitial
    if(String(fecha).length === 7){
        dateInitial = fecha
    }
    else{
        dateInitial = "1210101"
    }
    

    let anio = String(dateInitial).slice(1, 3);
    let mes = String(dateInitial).slice(3, 5);
    let dia = String(dateInitial).slice(5, 7);

    let meses = ['01','02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']

    //let fechaFormat = `${anio}-${mes}-${dia}`;
    //let fechaFormat = `${dia}-${mes}-${anio}`;
    let fechaFormat = `${dia}/${meses[Number(mes - 1)]}/${anio}`;

    return fechaFormat
}

export const dateFormatClaro = fecha => {
    let dateInitial
    if(String(fecha).length === 7){
        dateInitial = fecha
    }
    else{
        dateInitial = "1210101"
    }

    let anio = String(dateInitial).slice(1, 3);
    let mes = String(dateInitial).slice(3, 5);
    let dia = String(dateInitial).slice(5, 7);

    let meses = ['Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    let fechaFormat = `${dia} de ${meses[Number(mes - 1)]} 20${anio}`;

    return fechaFormat
}
export const dateFormatClaroSinAnio = fecha => {
    let dateInitial
    if(String(fecha).length === 7){
        dateInitial = fecha
    }
    else{
        dateInitial = "1210101"
    }

    let anio = String(dateInitial).slice(1, 3);
    let mes = String(dateInitial).slice(3, 5);
    let dia = String(dateInitial).slice(5, 7);

    let meses = ['Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    let fechaFormat = `${dia} ${meses[Number(mes - 1)]}`;

    return fechaFormat
}

export const dateFormatClaroConAnio = fecha => {
    let dateInitial
    if(String(fecha).length === 7){
        dateInitial = fecha
    }
    else{
        dateInitial = "1210101"
    }

    let anio = String(dateInitial).slice(1, 3);
    let mes = String(dateInitial).slice(3, 5);
    let dia = String(dateInitial).slice(5, 7);

    let meses = ['Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    let fechaFormat = `${dia} ${meses[Number(mes - 1)]}  20${anio}`;

    return fechaFormat
}

export const dateFormatDownload = fecha => {
    let dateInitial
    if(String(fecha).length === 7){
        dateInitial = fecha.split('/')
    }
    else{
        dateInitial = "01/2022"
    }

    let mes = String(dateInitial[0])
    let anio = String(dateInitial[1])

    let meses = ['Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    let fechaFormat = `${meses[Number(mes - 1)]} ${anio}`;


    return fechaFormat
}


export const dateFormatInvert = dateInitial => {

    let anio = String(dateInitial).split("-")[2];
    let mes = String(dateInitial).split("-")[1];
    let dia = String(dateInitial).split("-")[0];

    let meses = ['Ene','Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

    let fechaFormat = `1${anio}${meses.indexOf(mes )+ 1}${dia}`;

    return fechaFormat
}

export const dateFormatNumberInvert = dateInitial => {

    let anio = String(dateInitial).substr(2,2)
    let mes = String(dateInitial).substr(4,2)
    let dia = String(dateInitial).substr(6,2)



    let fechaFormat = Number(`1${anio}${mes}${dia}`);

    return fechaFormat
}


export const dateFormatDDMM = fecha => {
    let dateInitial
    if(String(fecha).length === 7){
        dateInitial = fecha
    }
    else{
        dateInitial = "1210101"
    }
    
    let anio = String(dateInitial).slice(1, 3);
    let mes = String(dateInitial).slice(3, 5);
    let dia = String(dateInitial).slice(5, 7);

    let meses = ['Ene','Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

    //let fechaFormat = `${anio}-${mes}-${dia}`;
    //let fechaFormat = `${dia}-${mes}-${anio}`;
    let fechaFormat = `${dia} ${meses[Number(mes - 1)]}`;

    return fechaFormat
}